"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicLoadManagerBase = void 0;
const core_1 = require("../core");
const dynamicLoadPlugin_types_1 = require("./dynamicLoadPlugin.types");
class DynamicLoadManagerBase extends core_1.CoreBasePluginModule {
    constructor(impl, options) {
        super({}, Object.assign({}, options));
        this.loadVertical = (verticalId, initializers) => __awaiter(this, void 0, void 0, function* () {
            const verticalConfig = yield this.impl.load(verticalId);
            this.executePluginMethod(dynamicLoadPlugin_types_1.DynamicLoadBasePluginMethods.BeforeInitialize, {
                verticalConfig,
                verticalId,
            });
            const initialized = yield this.impl.initialize(initializers, verticalConfig);
            this.executePluginMethod(dynamicLoadPlugin_types_1.DynamicLoadBasePluginMethods.AfterInitialize, {
                verticalConfig,
                verticalId,
            });
            return {
                initialized,
                verticalConfig,
            };
        });
        this.impl = impl;
    }
}
exports.DynamicLoadManagerBase = DynamicLoadManagerBase;
//# sourceMappingURL=dynamicLoadManager.js.map